<template>
  <div class="flex gap-2 cursor-pointer">
    <!-- <button
      v-bind:class="[
        { icon: displaySettings.play.displayAsIcon },
        globalClasses,
        displaySettings.play.classes,
      ]"
      v-bind:style="(globalStyles, displaySettings.play.style)"
      v-on:click="speak"
      v-if="displaySettings.play.show"
    >
      <i :class="displaySettings.play.icons"></i>
      {{ displaySettings.play.text }}
    </button>

    <button
      v-bind:class="[
        { icon: displaySettings.stop.displayAsIcon },
        globalClasses,
        displaySettings.stop.classes,
      ]"
      v-bind:style="(globalStyles, displaySettings.stop.style)"
      v-on:click="stop"
      v-if="displaySettings.stop.show"
    >
      <i :class="displaySettings.stop.icons"></i>
      {{ displaySettings.stop.text }}
    </button>

    <button
      v-bind:class="[
        { icon: displaySettings.pause.displayAsIcon },
        globalClasses,
        displaySettings.pause.classes,
      ]"
      v-bind:style="(globalStyles, displaySettings.pause.style)"
      v-on:click="pause"
      v-if="displaySettings.pause.show"
    >
      <i :class="displaySettings.pause.icons"></i>
      {{ displaySettings.pause.text }}
    </button> -->
    <img
      v-if="status === 'play'"
      src="../../../../assets/images/play.png"
      alt=""
      class="w-8 h-8"
      @click="speak"
    />
    <img
      v-if="status === 'pause'"
      src="../../../../assets/images/pause.png"
      alt=""
      class="w-8 h-8"
      @click="pausetts"
    />
    <img
      v-if="stopStatus === 'stop'"
      src="../../../../assets/images/stop.png"
      alt=""
      class="w-8 h-8"
      @click="stop"
    />
    <!-- <b-button
      class="mt-1 font-semibold lg:block md:block hidden sm-fsize10"
      size="sm"
      variant="outline-primary"
      @click="speak"
    >
      Listen
    </b-button>
    <b-button
      class="mt-1 font-semibold lg:block md:block hidden sm-fsize10"
      size="sm"
      variant="outline-danger"
      @click="speak"
    >
      Stop
    </b-button>
    <b-button
      class="mt-1 font-semibold lg:block md:block hidden sm-fsize10"
      size="sm"
      variant="outline-info"
      @click="pausetts"
    >
      Pause
    </b-button> -->
  </div>
</template>

<script type="text/javascript">
export default {
  props: [
    "text",
    "lang",
    "rate",
    "pitch",
    "voice",
    // "settings",
    // "classes",
    // "styles",
  ],

  mounted() {
    var self = this;

    this.pause = false;

    //this.$set('btnText', this.text);

    // this.$set("globalClasses", this.classes);

    // this.$set("globalStyles", this.styles);

    // if (this.settings && this.settings.play) {
    //   this.displaySettings.play = Object.assign(
    //     {},
    //     this.displaySettings.play,
    //     this.settings.play
    //   );
    // }
    // if (this.settings && this.settings.stop) {
    //   this.displaySettings.stop = Object.assign(
    //     {},
    //     this.displaySettings.stop,
    //     this.settings.stop
    //   );
    // }
    // if (this.settings && this.settings.pause) {
    //   this.displaySettings.pause = Object.assign(
    //     {},
    //     this.displaySettings.pause,
    //     this.settings.pause
    //   );
    // }

    // this.$set(
    //   "displaySettings.play",
    //   $.extend(this.displaySettings.play, this.settings.play)
    // );

    // this.$set(
    //   "displaySettings.stop",
    //   $.extend(this.displaySettings.stop, this.settings.stop)
    // );

    // this.$set(
    //   "displaySettings.pause",
    //   $.extend(this.displaySettings.pause, this.settings.pause)
    // );

    // this.utterance = new SpeechSynthesisUtterance();
    // console.log(this.utterance);

    this.getVoices();

    this.initSpeak();

    // Chrome loads voices asynchronously.

    window.speechSynthesis.onvoiceschanged = function (e) {
      self.getVoices();
    };

    // console.log("ready");
  },
  computed: {
    globalClasses() {
      return this.classes ? [this.classes] : [];
    },

    globalStyles() {
      return this.styles ? this.styles : {};
    },
  },

  methods: {
    speak() {
      // console.log("speak");
      // console.log(this.text);
      this.status = "pause";
      this.stopStatus = "stop";

      var self = this;

      this.initSpeak();

      //   console.log(this.utterance);

      this.utterance.text = this.text;

      this.utterance.pitch = this.pitch;

      this.utterance.lang = "en-US";

      this.utterance.voice =
        this.voice == undefined ? this.getVoiceByLanguage() : this.voice;

      //   console.log(this.utterance.voice);

      this.utterance.rate = this.rate == undefined ? 1 : this.rate;

      this.utterance.onstart = function () {
        self.notifyStart();
      };

      this.utterance.onend = function () {
        // console.log("ended");
        self.stop();

        self.notifyStop();
      };

      var i = 0;

      var words = self.utterance.text.split(" ");

      var charIndex = -1;

      //   console.log(this.utterance);

      if (this.pause) {
        this.pause = false;

        this.resume();
      } else {
        // console.log(this.utterance);

        window.speechSynthesis.speak(this.utterance);
      }
      //   console.log("test");
      this.utterance.onboundary = function (e) {
        // console.log("BOUNDARY");

        if (e.name == "word") {
          if (charIndex !== e.charIndex) {
            charIndex = e.charIndex;

            self.notifyWord(i);

            i += 1;
          } else {
            // console.log(e);
          }
        }
      };
    },

    initSpeak() {
      this.words = this.text.split(" ");

      this.notifyformattedText();
    },

    track() {
      console.log(this.utterance.text);
    },

    stop() {
      window.speechSynthesis.cancel(this.utterance);
      this.pause = false;
      this.status = "play";
      this.stopStatus = "";

      //   this.notifyStop();
    },

    pausetts() {
      this.pause = true;
      this.status = "play";

      window.speechSynthesis.pause(this.utterance);
    },

    resume() {
      window.speechSynthesis.resume(this.utterance);
    },

    getVoiceByLanguage() {
      var self = this;
      //   console.log(this.voices);

      for (var key in this.voices) {
        if (this.voices[key].lang == self.lang) {
          // console.log(this.voices[key]);
          return this.voices[key];
        }
      }

      return this.voices[0];
    },

    getVoices() {
      //   this.$set("voices", speechSynthesis.getVoices());
      this.voices = speechSynthesis.getVoices();
      //   console.log(speechSynthesis.getVoices());
      this.notifyVoices();
    },

    getVoice() {
      return this.voices[2];
    },

    notifyVoices() {
      this.$emit("tts-voices", this.voices);
    },

    notifyUtterance() {
      // emited the utterence insance to the parent incase callbacks are wanted on events.

      this.$emit("tts-utterance", this.utterence);
    },

    notifyWord(index) {
      this.$emit("tts-word", this.words[index], index);
    },

    notifyformattedText() {
      var text = "";

      for (var i = 0; i < this.words.length; i++) {
        text +=
          '<span id="tts-' +
          i +
          '" class="tts-word">' +
          this.words[i] +
          "</span> ";
      }

      this.$emit("tts-formatted-text", text);
    },

    notifyStart() {
      this.$emit("tts-start");
    },

    notifyPause() {
      this.$emit("tts-pause");
    },

    notifyStop() {
      this.$emit("tts-stop");
    },
  },

  beforeDestroy() {
    window.speechSynthesis.cancel(this.utterance);
    this.notifyStop();
  },

  data() {
    return {
      //   globalClasses: {},
      //   globalStyles: {},
      voices: [],
      utterance: new SpeechSynthesisUtterance(),
      selectVoice: {},
      status: "play",
      stopStatus: "",
      //   displaySettings: {
      //     play: {
      //       show: true,
      //       text: "Play",
      //       icons: "",
      //       displayAsIcon: false,
      //       classes: "",
      //       style: "",
      //     },
      //     stop: {
      //       show: true,
      //       text: "Stop",
      //       icons: "",
      //       displayAsIcon: false,
      //       classes: "",
      //       style: "",
      //     },

      //     pause: {
      //       show: true,
      //       text: "Pause",
      //       icons: "",
      //       displayAsIcon: false,
      //       classes: "",
      //       style: "",
      //     },
      //   },
      words: [],

      supported: true, // if the browser supports Text to speech
    };
  },
};
</script>
<style scoped></style>
